import React, { useState, useEffect } from 'react';
import { getAllPatientsWithQueueDetails } from '../../clientServices/PatientsService';
// import SelectRoom from '../QueuesManagment/SelectRoom';
import './MorePatientOptions.css';
import './ReceptionOperations.css';
import useReceptionSocket from '../../clientServices/ReceptionSocket';
import DeletePatientModal from '../QueuesManagment/modals/DeletePatient';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { getAllRooms } from '../../clientServices/RoomService';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Tooltip, Snackbar, Alert } from "@mui/material";
import { Box, Typography } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import RoomIcon from "@mui/icons-material/MeetingRoom";

const MorePatientOptions = (props) => {
    const [patients, setPatients] = useState([]);
    const [filteredPatients, setFilteredPatients] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedPatient, setSelectedPatient] = useState(null);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const { moveRoom, endOfTreatment } = useReceptionSocket(setSelectedPatient, patients, setPatients);
    const [rooms, setRooms] = useState([]);
    const [selectedRoom, setSelectedRoom] = useState('');
    const [selectedRoomName, setSelectedRoomName] = useState('');
    const [openSnackbar, setOpenSnackbar] = useState(false);

    useEffect(() => {
        const fetchRooms = async () => {
            try {
                const response = await getAllRooms();
                setRooms(response.data);
            } catch (error) {
                console.error('Error fetching rooms:', error);
            }
        };

        fetchRooms();
    }, []);

    const handleChange = (event) => {
        const roomName = event.target.value;
        const room = rooms.find(r => r.Name === roomName);
        setSelectedRoom(room);
        setSelectedRoomName(roomName);

    };

    useEffect(() => {
        const fetchPatients = async () => {
            try {
                const response = await getAllPatientsWithQueueDetails();
                const filteredData = response.data.data.filter(item => item.Tz !== null);
                setPatients(filteredData || []);
                setFilteredPatients(filteredData || []);
            } catch (error) {
                console.error('Error fetching patients:', error);
            }
        };

        fetchPatients();
    }, []);

    useEffect(() => {
        if (patients.length > 0) {
            console.log(patients)
            if (props.roomName === "קבלה") {
                setFilteredPatients(patients); // לא מסנן אם החדר הוא "קבלה"
            } else {
                const filteredByRoom = patients.filter(patient =>
                    patient.queues &&
                    patient.queues.length > 0 &&
                    patient.queues[0].room.Name === props.roomName
                );
                console.log(filteredByRoom)
                setFilteredPatients(filteredByRoom);
            }
        }
    }, [patients, props.roomName]);

    useEffect(() => {
        if (patients.length > 0) {
            const filterResults = patients.filter((patient) =>
                (patient.UniqueNumber || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
                String(patient.Tz || '').toLowerCase().includes(searchQuery.toLowerCase())
            );
            setFilteredPatients(filterResults);
        }
    }, [searchQuery, patients]);

    const handleRowClick = (patient) => {
        setSelectedPatient(patient);
    };

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const handleMoveToEndOfQueue = async () => {
        if (selectedPatient && selectedRoom) {
            try {
                await moveRoom(selectedRoom.ID, selectedPatient.ID, true);
                alert('המטופל הועבר לתור בהצלחה');
                setSelectedPatient(null);
                setSelectedRoom(null);
                setSelectedRoomName('');
            } catch (error) {
                console.error('Error moving patient to end of queue:', error);
                alert('שגיאה בהעברת מטופל');
            }
        } else {
            if (!selectedPatient) {
                alert('בחר מטופל');
            }
            if (!selectedRoom) {
                alert('בחר חדר');
            }
        }
    };

    const handleMoveToFrontOfQueue = async () => {
        if (selectedPatient && selectedRoom) {
            try {
                await moveRoom(selectedRoom.ID, selectedPatient.ID, false);
                alert('המטופל הועבר לתחילת התור בהצלחה');
                setSelectedPatient(null);
                setSelectedRoom(null);
                setSelectedRoomName('');
            } catch (error) {
                console.error('Error moving patient to front of queue:', error);
                alert('שגיאה בהעברת מטופל לתחילת התור');
            }
        } else {
            if (!selectedPatient) {
                alert('בחר מטופל');
            }
            if (!selectedRoom) {
                alert('בחר חדר');
            }
        }
    };

    const handleFinishTreatment = async () => {
        if (selectedPatient) {
            setIsDeleteModalOpen(true);
        } else {
            alert('בחר מטופל');
        }
    };

    const handleCloseDeleteModal = () => {
        setIsDeleteModalOpen(false);
    };

    const handleConfirmDeleteModal = async () => {
        if (selectedPatient) {
            try {
                await endOfTreatment(selectedPatient.ID);
                setPatients(patients.filter(patient => patient.ID !== selectedPatient.ID));
                setIsDeleteModalOpen(false);
                setSelectedPatient(null);
                alert('טיפול הסתיים בהצלחה');
            } catch (error) {
                console.error('Error finishing treatment:', error);
                alert('Failed to finish treatment.');
            }
        }
    };

    const handleCopy = async (text) => {
        try {
            if (navigator.clipboard && window.isSecureContext) {
                await navigator.clipboard.writeText(text);
            } else {
                // Fallback לשיטה ישנה
                const textArea = document.createElement("textarea");
                textArea.value = text;
                textArea.style.position = "fixed";  // שלא יזוז במסך
                textArea.style.opacity = "0";       // שלא ייראה
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();

                const successful = document.execCommand('copy');
                if (!successful) throw new Error('Fallback copy failed');

                document.body.removeChild(textArea);
            }
            setOpenSnackbar(true); // הודעה על הצלחה
        } catch (err) {
            console.error("שגיאה בהעתקת הטקסט:", err);
        }
    };


    return (
        <>
            <div className='MorePatientOptionsContainer'>
                {selectedPatient ? (
                    <Box
                        sx={{
                            bgcolor: "#e3f2fd", // רקע תכלת בהיר
                            borderRight: "4px solid #1976d2", // פס צד מודגש
                            borderRadius: "20px",
                            p: 1.5,
                            width: "50%",
                            margin: "0 auto",
                            display: "flex",
                            flexDirection: "column",
                            gap: 1,
                            direction: "rtl",
                            marginBottom: "10px"
                        }}
                    >
                        <Box display="flex" alignItems="center" gap={0.5}>
                            <PersonIcon fontSize="small" sx={{ color: "#1976d2" }} />
                            <Typography variant="body2" sx={{ fontWeight: 500, fontFamily: "Segoe UI, Tahoma, Geneva, Verdana, sans-serif" }}>
                                {selectedPatient.UniqueNumber} | {selectedPatient.Tz}
                            </Typography>
                        </Box>
                        <Box display="flex" alignItems="center" gap={0.5}>
                            <RoomIcon fontSize="small" sx={{ color: "#1976d2" }} />
                            <Typography variant="body2"
                                sx={{
                                    fontFamily: "Segoe UI, Tahoma, Geneva, Verdana, sans-serif"
                                }}
                            >
                                חדר נוכחי:{" "}
                                {selectedPatient.queues.length > 0
                                    ? selectedPatient.queues[0].room.Name
                                    : "N/A"}
                            </Typography>
                        </Box>
                    </Box>
                ) : (
                    <Box
                        sx={{
                            bgcolor: "#ffe0e0",
                            borderRight: "4px solid #d32f2f",
                            p: 1.5,
                            width: "40%",
                            margin: "0 auto",
                            textAlign: "center",
                            direction: "rtl",
                            borderRadius: "20px",
                            marginBottom: "10px",
                            fontFamily: "Segoe UI, Tahoma, Geneva, Verdana, sans-serif"
                        }}
                    >
                        <Typography variant="body2" sx={{
                            fontWeight: "bold", fontFamily: "Segoe UI, Tahoma, Geneva, Verdana, sans-serif"
                        }}>
                            לא נבחר מטופל
                        </Typography>
                    </Box>
                )}


                <input
                    type="text"
                    placeholder="חיפוש לפי מספר יחודי או זהות"
                    value={searchQuery}
                    onChange={handleSearchChange}
                    className="search-input"
                />

                <div className="table-wrapper">
                    <table className="small-table">
                        <thead>
                            <tr>
                                <th>מספר יחודי</th>
                                <th>מספר זהות</th>
                                <th>חדר נוכחי</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredPatients && filteredPatients.length > 0 ? (
                                filteredPatients.map((patient) => (
                                    <tr
                                        key={patient.ID}
                                        className={selectedPatient?.ID === patient.ID ? 'selected' : ''}
                                        onClick={() => handleRowClick(patient)}
                                    >
                                        <td>{patient.UniqueNumber}</td>
                                        <td>{patient.Tz}</td>
                                        <td>{patient.queues && patient.queues.length > 0 ? patient.queues[0].room.Name : 'N/A'}</td>
                                        <td>
                                            <Tooltip title={`העתק: ${patient.Tz}`} arrow>

                                                <button
                                                    className='copyBtn'
                                                    variant="contained"
                                                    onClick={() => handleCopy(`${patient.Tz}`)}
                                                >
                                                    <ContentCopyIcon />
                                                </button>
                                            </Tooltip>

                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="3">לא נמצאו מטופלים</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="ReceptionOperationsCont">
                    <div className='btn-cont-reception'>
                        <div>
                            <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                                <InputLabel id="room-select-label">בחר חדר</InputLabel>
                                <Select
                                    labelId="room-select-label"
                                    id="room-select"
                                    value={selectedRoomName}
                                    label="בחר חדר"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="">
                                        <em>בחירת חדר</em>
                                    </MenuItem>
                                    {rooms.length > 0 && rooms.map((room) => (
                                        <MenuItem key={room.ID} value={room.Name}>
                                            {room.Name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>

                        <button className="action-reception-btn" onClick={handleMoveToFrontOfQueue}>
                            העבר לראש התור
                        </button>
                        <button className="action-reception-btn" onClick={handleMoveToEndOfQueue}>
                            העבר לחדר
                        </button>
                    </div>

                    <button className="endTreatBtn" onClick={handleFinishTreatment}>
                        <div>סיום טיפול</div>
                    </button>
                </div>
            </div>

            <DeletePatientModal
                open={isDeleteModalOpen}
                handleClose={handleCloseDeleteModal}
                handleConfirm={handleConfirmDeleteModal}
                patientName={selectedPatient ? `${selectedPatient.UniqueNumber}` : ''}
            />

            <Snackbar
                open={openSnackbar}
                autoHideDuration={2000} // ההודעה נסגרת אחרי 3 שניות
                onClose={() => setOpenSnackbar(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert
                    onClose={() => setOpenSnackbar(false)}
                    severity="success"
                    variant="filled"
                    sx={{ bgcolor: '#2196F3', color: 'white' }}
                >                    מספר זהות הועתק בהצלחה
                </Alert>
            </Snackbar>
        </>
    );
};

export default MorePatientOptions;
